<template>
  <div class="payment">
    <div class="order">
      <div class="f32 color-333 fb tl">支付方式</div>
      <div class="pt20" v-for="item in list" :key="item.id">
        <GxxtRadio class="wp" name="a" :value="cur" :label="item.id" @change="change">
          <span slot="icon">
            <img :src="item.path" alt />
          </span>
          {{item.name}}
        </GxxtRadio>
      </div>
    </div>
  </div>
</template>

<script>
import { GxxtRadio } from '@/components'
export default {
  components: { GxxtRadio },
  data() {
    return {
      cur: 0,
      list: [
        {
          id: 0,
          name: '微信支付',
          path: require('@/assets/images/vip/weixin.png'),
        },
        {
          id: 4,
          name: '对公支付',
          path: require('@/assets/images/vip/order-w.png'),
        },
      ],
    }
  },
  emits: ['select'],
  methods: {
    change(v) {
      this.cur = v
      this.$emit('select', v)
    },
  },
}
</script>

<style lang="less" scoped>
.payment {
  margin: 0 auto;
  .order {
    width: 686px;
    background: #ffffff;
    border-radius: 10px;
    padding: 30px;
  }
}

img {
  width: 40px;
  height: 40px;
  margin-right: 16px;
  position: relative;
  top: 10px;
}
</style>
